import React, { useContext } from "react"
import { Trophy } from "lucide-react"

import { BookingContext } from "../../../utils/providers/isolated-booking"

import styles from "./practical.module.scss"

/**
 * Stableford points — the loyalty points earned on this booking and what
 * they're worth off the next one.
 */
export default function Stableford() {
	const { stablefordPoints } = useContext(BookingContext)

	const points = Number(stablefordPoints || 0)
	const reward = (points / 10).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })

	return (
		<div className={styles.page}>
			<header className={styles.head}>
				<h1>Stableford points</h1>
				<p>Your loyalty reward for booking with us.</p>
			</header>

			<div className={styles.stableford}>
				<span className={styles.stablefordIcon}>
					<Trophy size={26} />
				</span>

				<div className={styles.points}>{points.toLocaleString("en-GB")}</div>
				<p className={styles.pointsLabel}>points earned on this booking</p>

				<div className={styles.pointsValue}>
					That's <strong>£{reward}</strong> off your next holiday with us
				</div>

				<p className={styles.stablefordExplainer}>
					For every £10 you spend on a booking you earn one Stableford point, and every 10 points takes £1 off a future booking.{" "}
					<a
						href="https://www.golfholidaysdirect.com/stableford/"
						target="_blank"
						rel="noreferrer">
						Learn more
					</a>
					.
				</p>
			</div>
		</div>
	)
}
